import React, { useState, useEffect } from "react";
import logo from "../assets/images/boots-myhealthchecked-logo.svg"
import Boots from "../assets/images/Vector.svg";
import { Nav, Navbar, Image } from "react-bootstrap";
import Logout from "../views/Account/Logout";
import { useAuth } from "../components/AuthContext/AuthContext";
import { useLocation } from "react-router-dom";
import { getTestTypeValueFromUrl, getRouteCategory, desktopMenu } from "../utils";
import { ListGroupItem } from "./ListGroupItem";

/**
 * Sidebar navigation component for the application.
 * @returns {JSX.Element} The sidebar with menu items and branding.
 */

const SideBar = props => {
  const [menu, setMenu] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const auth = useAuth();
  const location = useLocation();
  const phlebotomy = localStorage.getItem("is_phlebotomist");
  const testType = localStorage.getItem("test_type");
  // Effect to set menu items based on the phlebotomy flag
  useEffect(() => {
    setIsLoading(true);
    if (
      auth?.isAuthenticated ||
      JSON.parse(localStorage.getItem("isLoggedIn"))
    ) {
      let currentMenu;
      if (auth.isHcpLive && phlebotomy === "true") {
        currentMenu = (desktopMenu?.hcp_menu);
        
        // Update the Boots appointment URL with current test type
        const bootsMenuItem = currentMenu.find(item => item.category === "appointment-booking");
        if (bootsMenuItem) {
          const currentTestType = getTestTypeValueFromUrl(testType);
          bootsMenuItem.to = `/bloods/boots/${currentTestType}`;
        }
        
        setMenu(currentMenu);
      } else {
        setMenu(desktopMenu?.neo_menu);
      }
    } else {
      setMenu(null); // Clear the menu on logout
    }
    setIsLoading(false);
  }, [
    auth,
    JSON.parse(localStorage?.getItem("isLoggedIn")),
    testType,
    auth?.toast,
    phlebotomy,
    auth.isHcpLive
  ]);

  // Conditional rendering for logout
  const renderLogoutButton = auth?.isAuthenticated || JSON.parse(localStorage.getItem("isLoggedIn"));

  return (
    <div className="main-row m-0 row">
      <div className="sidebar-container sidebar-background p-0 col">
        <div className="sidebar-background p-0 m-0 overflow-hidden sticky-top col">
          <div className="row">
            <div className="col-12 col-md-12">
              <Navbar className="" expand="lg">
                <div className="d-inline fs-1-2 container-fluid custom-sidebar">
                  <Navbar.Brand>
                    <a href="/">
                      <Image
                        alt="My Health Checked"
                        className="d-block mhc-logo mt-1"
                        src={logo}
                      />
                    </a>
                  </Navbar.Brand>
                  <Navbar.Toggle aria-controls="basic-navbar-nav" />
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="flex-column ms-1">
                      {menu?.map((m, index) => (
                        <ListGroupItem
                          key={m.to}
                          to={m.to}
                          active={m.category === getRouteCategory(location.pathname)}
                          icon={m.icon}
                          title={m.name}
                          isMobile={false}
                        />
                      ))}
                    </Nav>
                    {!isLoading && renderLogoutButton && menu && <Logout isMobileView={false} />}
                  </Navbar.Collapse>
                </div>
              </Navbar>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
